import Cookies from 'js-cookie';
import { Session } from './session';
import { sessionCookieName } from '../const';

const getCsrSession = (): Session | null => {
  let session: Session | undefined;
  const authSessionCookie: string | undefined = Cookies.get(sessionCookieName);
  if (authSessionCookie) {
    session = JSON.parse(authSessionCookie);
  }
  return session ?? null;
};

export default getCsrSession;
